export const SET_LOADING = 'SET_LOADING';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_APP_SCENE = 'SET_APP_SCENE';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_SUBJECT_TYPES_LIST = 'SET_SUBJECT_TYPES_LIST';
export const SET_SUBJECT_TYPES_LIST_FILTERED = 'SET_SUBJECT_TYPES_LIST_FILTERED';

export const SET_PROCESS_NUMBER_DETAILS = 'SET_PROCESS_NUMBER_DETAILS';
